import axios from 'axios'

export default {
  getAll ( params, callback ) {
    axios.get('/clients', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getClients ( params, callback ) {
    params['is_supplier'] = 0;
    this.getAll(params, callback);
  },
  getSuppliers ( params, callback ) {
    params['is_supplier'] = 1;
    this.getAll(params, callback);
  },
  getClient ( clientId, callback, fallback ) {
    axios.get('/clients/' + clientId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  create ( data, callback, fallback ) {
    axios.post( '/clients', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( clientId, data, callback, fallback ) {
    axios.post( '/clients/' + clientId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( clientId, callback, fallback ) {
    axios.delete( '/clients/' + clientId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getAllMembers ( params, callback ) {
    axios.get('/clients/members', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getMembers ( clientId, params, callback ) {
    axios.get('/clients/' + clientId + '/members', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  createMember ( clientId, data, callback, fallback ) {
    axios.post( '/clients/' + clientId + '/members', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  saveMember ( clientId, memberId, data, callback, fallback ) {
    axios.post( '/clients/' + clientId + '/members/' + memberId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  deleteMember ( clientId, memberId, callback, fallback ) {
    axios.delete( '/clients/' + clientId + '/members/' + memberId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  createJob ( clientId, data, callback, fallback ) {
    axios.post( '/clients/' + clientId + '/jobs', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
}
